import { useRef, useState } from "react";
import { Box } from "@mui/material";
import { theme } from "@/index";
import AppsListV2 from "./AppListV2/AppsListV2";
import UserInfoV2 from "./UserInfoV2/UserInfoV2";
import {
  StyledContainer,
  StyledLeftSection,
  StyledLogo,
  StyledRightSection,
  StyledDivider,
} from "./HeaderV2.styles";
import { useAuth } from "@/context/AuthContext";
import Title from "./TitleV2/TitleV2";
import CustomLogoIcon from "./CustomLogoV2/CustomLogoV2";
import { useLocation } from "react-router-dom";
import { useUserMeV2 } from "@/hooks/useUsersV2";

const HeaderV2 = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorAppsList, setAnchorAppsList] = useState(null);
  const { logout } = useAuth();
  const { user } = useUserMeV2();

  const userEmail = user?.email;
  const userFullName = user?.name;
  const userRoles = user?.role_associations.map((role) => role.name).join(", ");

  const arrowRef = useRef(null);
  const location = useLocation();

  const isV2Pathname = location.pathname === "administrationv2";

  const openMenu = (event) => {
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };

  const openAppsList = (event) => {
    event.preventDefault();
    setAnchorAppsList(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
    setAnchorAppsList(null);
  };

  const handleLogout = async () => {
    localStorage.clear();
    sessionStorage.clear();
    logout();
  };

  return (
    <StyledContainer container>
      <StyledLeftSection size={6}>
        <StyledLogo>
          <CustomLogoIcon
            style={{
              fontSize: "20px",
              width: "120px",
              color: theme.palette.secondary.main,
            }}
          />
        </StyledLogo>
      </StyledLeftSection>

      <StyledRightSection size={6}>
        <UserInfoV2
          userName={userFullName}
          userEmail={userEmail}
          userRoles={userRoles}
          anchorEl={anchorEl}
          openMenu={(e) => openMenu(e)}
          closeMenu={closeMenu}
          logout={handleLogout}
        />

        {/* <StyledDivider orientation="vertical" />

        <AppsListV2
          openAppsList={openAppsList}
          anchorAppsList={anchorAppsList}
          arrowRef={arrowRef}
          closeMenu={closeMenu}
        /> */}
      </StyledRightSection>
      {location.pathname.includes("/administrationv2") ? null : (
        <Box
          sx={{
            backgroundColor: "var(--silver-200)",
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            padding: "0 2.5%",
            height: "136px",
          }}
        >
          <Title />
        </Box>
      )}
    </StyledContainer>
  );
};

export default HeaderV2;
